import { Component, createRef } from 'react';
import type { ReactNode, RefObject } from 'react';
import { ScrollLoaderWrapper, ScrollPane, IntersectionBox } from './styled';
import Observer from '@researchgate/react-intersection-observer';

interface State {
  direction: string;
}

interface Props {
  children: (direction: string, reset: () => void) => ReactNode;
  handleLoadRequest: () => void;
  muteScrollEvent: boolean;
  paddingTop: number;
}

class ScrollLoader extends Component<Props, State> {
  private scrollingPane: RefObject<HTMLDivElement>;
  currentScrollTop = 0;
  static defaultProps = {
    handleLoadRequest: null,
    muteScrollEvent: false,
    paddingTop: 0,
  };

  constructor(props) {
    super(props);
    this.state = {
      direction: 'down',
    };
    this.scrollingPane = createRef<HTMLDivElement>();
  }

  componentDidMount() {
    const { scrollingPane, handleScroll } = this;

    const { current } = scrollingPane;
    if (current) current.addEventListener('scroll', handleScroll);
  }

  componentWillUnmount() {
    const { scrollingPane, handleScroll } = this;
    const { current } = scrollingPane;
    if (current) current.removeEventListener('scroll', handleScroll);
  }

  handleScroll = () => {
    const { scrollingPane } = this;
    const { current } = scrollingPane;
    if (!current) return;
    const { offsetHeight, scrollTop, scrollHeight } = current;
    const { handleLoadRequest, paddingTop, muteScrollEvent } = this.props;
    if (scrollHeight < offsetHeight - paddingTop || muteScrollEvent)
      return false;
    if (offsetHeight + scrollTop > scrollHeight - offsetHeight) {
      handleLoadRequest();
    }

    if (this.currentScrollTop < scrollTop || this.currentScrollTop < 100) {
      this.setState({ direction: 'down' });
    } else if (this.currentScrollTop > offsetHeight) {
      this.setState({ direction: 'up' });
    }
    this.currentScrollTop = scrollTop;
  };
  resetContainerScroll = () => {
    const { current } = this.scrollingPane;
    if (current) current.scroll(0, 0);
  };
  handleObserverOnChange = ({ isIntersecting }) => {
    if (isIntersecting) {
      const { muteScrollEvent } = this.props;
      if (muteScrollEvent) return;
      this.props.handleLoadRequest();
    }
  };
  render() {
    const { children, paddingTop } = this.props;
    return (
      <ScrollLoaderWrapper>
        <ScrollPane
          paddingTop={paddingTop}
          ref={this.scrollingPane}
          data-cy-id="scroll-pane"
        >
          {children(this.state.direction, this.resetContainerScroll)}
        </ScrollPane>
        <Observer onChange={this.handleObserverOnChange}>
          <IntersectionBox />
        </Observer>
      </ScrollLoaderWrapper>
    );
  }
}

export default ScrollLoader;
